.screen {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  color: var(--text);
  padding-top: var(--inset-top, 0px);
  padding-bottom: var(--inset-bottom, 0px);
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--muted);
}

.status i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--danger);
  animation: blink 2s infinite;
}

@keyframes blink {
  50% {
    opacity: 0.35;
  }
}

.body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 24px;
  text-align: center;
}

.eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--accent);
}

.title {
  margin: 0 0 8px;
  max-width: 22ch;
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 500;
  font-size: clamp(26px, 4vw, 36px);
  line-height: 1.15;
  text-wrap: balance;
}

.foot {
  padding: 0 20px 24px;
  text-align: center;
  font-size: 13px;
  color: var(--muted);
}

.foot button {
  border: 0;
  padding: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

@media (prefers-reduced-motion: reduce) {
  .status i {
    animation: none;
  }
}
